export class GWAcknowledgement {
    public id: number;
    public quoteId: number;
    public dateAcknowledged: string;
    public code: string;
    public messageToDisplay: string;
    public type: string;
    public typeIdentifier: string;
    public relatedType: string;
    public relatedTypeIdentifier: string;
    public coverageRatingIds: string[];
    public externalId: string;
    public message: string;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/shared/models/agents-gateway/save-quote/gw-acknowledgement.model.ts